import { render, staticRenderFns } from "./dic_process_list.vue?vue&type=template&id=43125b61&scoped=true"
import script from "./dic_process_list.vue?vue&type=script&lang=js"
export * from "./dic_process_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43125b61",
  null
  
)

export default component.exports